import React, { useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import i18next from "i18next";
import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";
import { get as lodashGet } from "lodash";
import { CreditsafeIndicators, getCreditsafeOptionsDependingOnScore } from "services/common/CreditsafeUtils";
import EAAutoCompleteInput from "components/inputs/EAAutoCompleteInput";

export function ThirdpartiesSearchCreditsafe({filters}) {
 const formMethods = useFormContext();

   const { control, setValue } = useFormContext();
 
   const { fields } = useFieldArray({
     control,
     name: "creditsafe",
   });
 
     useEffect(() => {
       if (filters?.creditsafe) {
         filters.creditsafe?.forEach((filter) => {
           const fieldIndex = fields.findIndex((field) => field.score === filter.score);
           setValue(`creditsafe.${fieldIndex}.values`, filter.values || []);
          
         });
       }
     }, [fields, setValue, filters]);

 
   return (
     <>
       {
         fields?.map((field, index) => {
           return (
             field.score !== CreditsafeIndicators.NATIONAL_SCORE && 
             field.score !== CreditsafeIndicators.PAYMENT_BEHAVIOR && (
               <Grid item xs={3} key={field.id}>
                 <SearchFormInputBloc
                   label={i18next.t(`creditsafe.scores.${field.score}`)}
                   hasTooltip
                 >
                   {(() => {
                     const fieldName = `creditsafe.${index}.values`;
                     switch (field.score) {
                       case CreditsafeIndicators.CREDIT_LIMIT:
                         return (
                           <Controller
                             control={formMethods.control}
                             name={fieldName}
                             render={({ field }) => (
                               <TextField
                                 {...field}
                                 id="creditsafe-value-id"
                                 variant="outlined"
                                 fullWidth
                                 placeholder={i18next.t('thirdpartySearch.search')}
                                 error={
                                   !!lodashGet(
                                     formMethods.formState.errors,
                                     fieldName
                                   )
                                 }
                                 helperText={
                                   !!lodashGet(
                                     formMethods.formState.errors,
                                     fieldName
                                   )
                                     ? lodashGet(
                                       formMethods.formState.errors,
                                       fieldName
                                     ).message
                                     : ""
                                 }
                               />
                             )}
                           />
                         );

                       default:
                         return (
                           <EAAutoCompleteInput
                             fieldName={fieldName}
                             options={getCreditsafeOptionsDependingOnScore(field.score, true)}
                             defaultOption={i18next.t("all")}
                             variant="outlined"
                             placeholder={i18next.t("all")}
                             multiple
                             limitTags={1}
                           />
                         );
                     }
                   })()}
                 </SearchFormInputBloc>
               </Grid>
             )
           );
         })
       }
     </>
   );
 }